import React, { FC, memo, useContext, useState, useCallback } from 'react'
import { ScreenContext } from 'react-components'
import { AccommodationItemTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'
import { getBasePath } from '../../../utils/miscellaneous-utils'
import HolidayIdeaListItem from './holiday-ideas-list-item'
import {
    Wrapper,
    Header,
    HeaderContent,
    HeaderText,
    HeaderImg,
    ListContainer,
    List,
    ViewMoreContainer,
    ViewMoreButton,
    ViewMoreText,
    ArrowIcon,
} from './styles'
import { Title, Subtitle } from '../common/styles'

interface HolidayIdeaProps {
    items: AccommodationItemTransport[]
}

const HolidayIdeaSection: FC<HolidayIdeaProps> = ({ items }) => {
    const { t } = useTranslation()
    const { isDesktop } = useContext(ScreenContext)
    const [expanded, setExpanded] = useState(false)

    const shouldShowViewMoreButton = !isDesktop && items.length > 6

    const paperPlaneIcon = getBasePath('/assets/images/holiday-ideas/header/paper-plane.png?imwidth=100')

    const _handleToggleExpanded = useCallback(() => {
        // Defer state update to avoid blocking the click
        setTimeout(() => {
            setExpanded(prevExpanded => !prevExpanded)
        }, 0)
    }, [])

    return (
        <>
            <Wrapper>
                <Header>
                    <HeaderContent>
                        <HeaderText>
                            <Title>{t('pages.home.holidayIdeas.heading')}</Title>
                            <Subtitle>{t('pages.home.holidayIdeas.subheading')}</Subtitle>
                        </HeaderText>
                        <HeaderImg src={paperPlaneIcon} alt="" />
                    </HeaderContent>
                </Header>

                <ListContainer>
                    <List expanded={expanded}>
                        {items.map((item, index) => (
                            <HolidayIdeaListItem key={item.id} item={item} index={index} />
                        ))}
                    </List>
                </ListContainer>
            </Wrapper>

            {shouldShowViewMoreButton && (
                <ViewMoreContainer>
                    <ViewMoreButton onClick={_handleToggleExpanded} aria-expanded={expanded}>
                        <ViewMoreText>{expanded ? t('showLess') : t('showMore')}</ViewMoreText>
                        <ArrowIcon expanded={expanded} />
                    </ViewMoreButton>
                </ViewMoreContainer>
            )}
        </>
    )
}

export default memo(HolidayIdeaSection)
